import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PremiumModalService } from '../../../dashboard/services/premium-modal.service';

@Component({
  selector: 'kt-app-premium-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './premium-modal.component.html',
  styleUrl: './premium-modal.component.scss'
})
export class PremiumModalComponent {
  protected readonly premiumModal = inject(PremiumModalService);
}
